/** Clamp [from, to] so the span does not exceed maxRangeMs by moving `from` forward. */
export const clampDatePairToMaxRangeMs = (from: Date, to: Date, maxRangeMs: number): { fromDate: Date; toDate: Date } => {
    if (to.getTime() - from.getTime() <= maxRangeMs) {
        return { fromDate: from, toDate: to };
    }
    return { fromDate: new Date(to.getTime() - maxRangeMs), toDate: to };
};

export const toDateInputValue = (isoOrDate: string | Date | null | undefined): string => {
    if (!isoOrDate) return '';
    const date = typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate;
    if (Number.isNaN(date.getTime())) return '';
    return date.toISOString().split('T')[0];
};

/** HTML date input bounds when maxRangeMs is set and one side of the range is known. */
export const getDateInputBounds = (
    fromDate: string | null,
    toDate: string | null,
    maxRangeMs: number | undefined
): { fromMin?: string; fromMax?: string; toMin?: string; toMax?: string } => {
    if (maxRangeMs == null) {
        return {};
    }

    const bounds: { fromMin?: string; fromMax?: string; toMin?: string; toMax?: string } = {};

    if (toDate) {
        const to = new Date(toDate);
        bounds.fromMax = toDateInputValue(to);
        bounds.fromMin = toDateInputValue(new Date(to.getTime() - maxRangeMs));
    }

    if (fromDate) {
        const from = new Date(fromDate);
        bounds.toMin = toDateInputValue(from);
        bounds.toMax = toDateInputValue(new Date(from.getTime() + maxRangeMs));
    }

    return bounds;
};
